import React from 'react'
import { LOCALE } from '@/constants/activity-constants'

const DEFAULT_PARAGRAPH1 = (
  <p>
    <b>Ayuda a V-Bot</b> a crear productos Nosotras para hacerlos llegar a más
    mujeres alrededor del mundo.
  </p>
)
const paragraph1 =
  {
    'es-CO': DEFAULT_PARAGRAPH1,
    'es-PE': (
      <p>
        <b>Ayuda a V-Bot</b> a crear productos Nosotras y haz que lleguen a más
        mujeres alrededor del mundo.
      </p>
    ),
    'es-AR': (
      <p>
        <b>Ayudá a V-Bot</b> a crear productos Nosotras y hacé que lleguen a más
        mujeres alrededor del mundo.
      </p>
    ),
    'es-CL': (
      <p>
        <b>Ayudá a V-Bot</b>a crear productos Nosotras y haz que lleguen a más
        mujeres alrededor del mundo.
      </p>
    ),
  }[LOCALE] || DEFAULT_PARAGRAPH1

const TEXTOS = { paragraph1 }
export default TEXTOS
